export interface Category {
  name: string;
  displayName: string;
  url: string;
  description: string;
  seq: string;
}

export const categories: Category[] = [
  {
    name: "Shoes",
    displayName: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    description: "Sneakers, Boots & Footwear",
    seq: "category-shoes-001",
  },
  {
    name: "Hoodies/Sweaters",
    displayName: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    description: "Hoodies, Crewnecks & Knits",
    seq: "category-hoodies-002",
  },
  {
    name: "T-Shirts",
    displayName: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    description: "Graphic Tees & Basics",
    seq: "category-tshirts-003",
  },
  {
    name: "Jackets",
    displayName: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    description: "Outerwear & Coats",
    seq: "category-jackets-004",
  },
  {
    name: "Pants/Shorts",
    displayName: "Pants/Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    description: "Jeans, Cargos & Shorts",
    seq: "category-pants-005",
  },
  {
    name: "Headwear",
    displayName: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    description: "Caps, Beanies & Hats",
    seq: "category-headwear-006",
  },
  {
    name: "Sets",
    displayName: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    description: "Matching Outfit Sets",
    seq: "category-sets-007",
  },
  {
    name: "Underwear/Underpants",
    displayName: "Underwear/Underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    description: "Essentials & Basics",
    seq: "category-underwear-008",
  },
  {
    name: "Jersey",
    displayName: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    description: "Sports Jerseys & Kits",
    seq: "category-jersey-009",
  },
  {
    name: "Accessories",
    displayName: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    description: "Watches, Jewelry & More",
    seq: "category-accessories-010",
  },
  {
    name: "Bags",
    displayName: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    description: "Backpacks, Totes & Luggage",
    seq: "category-bags-011",
  },
  {
    name: "Belts",
    displayName: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    description: "Leather & Casual Belts",
    seq: "category-belts-012",
  },
  {
    name: "Perfumes",
    displayName: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    description: "Fragrances & Colognes",
    seq: "category-perfumes-013",
  },
  {
    name: "Other Stuff",
    displayName: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    description: "Miscellaneous Finds",
    seq: "category-other-014",
  },
];

export const mainSiteUrl = "https://kaspreadsheet.com";